import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { Alert, SpinnerOverlay, Text } from '@quality24/design-system';

import {
  FRONTEND_ERROR_CODE as ERROR_CODE,
  FrontEndError,
} from '@quality24/error-codes';
import { getRedirectUri } from '../../utils/url';
import { useAuth } from '../../contexts/auth/useAuth';
import { cookieStorage } from '../../utils/cookies';

const LogoutPage: React.FunctionComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { inProgress, error, signOut } = useAuth();

  /** Store clientId and redirectUri in cookies in case of federated logout. */
  React.useEffect(() => {
    if (cookieStorage.getItem('amplify-signin-with-hostedUI') === 'true') {
      const query = new URLSearchParams(location.search);
      const clientId = query.get('clientId');
      const redirectUri = query.get('redirect_uri');

      if (clientId) {
        cookieStorage.setItem('last-logout-clientId', clientId);
      }

      if (redirectUri) {
        cookieStorage.setItem('last-logout-redirectUri', redirectUri);
      }
    }

    /** Add a little timeout to allow the user to read the error message */
    const timeout = setTimeout(() => {
      signOut().then(() => {
        const uri = getRedirectUri(location.search);
        if (!process.env.REACT_APP_PREVENT_REDIRECT) {
          if (uri) {
            window.location.replace(uri);
          } else {
            navigate('/login');
          }
        }
      });
    }, 2000);

    return () => clearTimeout(timeout);
  }, [signOut, location, navigate]);

  const message = React.useMemo(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const parsedMessage = ERROR_CODE[code as unknown as FrontEndError];
    return parsedMessage;
  }, [location.search]);

  return (
    <>
      {error && (
        <Alert className="mb-3" variant="danger">
          {error}
        </Alert>
      )}
      {inProgress && <SpinnerOverlay size="sm" />}

      {message && (
        <div className="mb-2" data-testid="message">
          {message}
        </div>
      )}
      <div>
        <Text>Aguarde nesta tela enquanto te deslogamos.</Text>
      </div>
    </>
  );
};

export default LogoutPage;
